import React from "react";
import {
  apiCallPost,
  apiCallPostMultipartProgress,
  niceDateTime,
} from "../fns/util";
import { inject, observer } from "mobx-react";
import cogoToast from "cogo-toast";
import {
  AnchorButton,
  Button,
  Collapse,
  ControlGroup,
  FileInput,
  InputGroup,
  ProgressBar,
  Spinner,
  Tag,
} from "@blueprintjs/core";

class EntityFiles extends React.Component {
  state = {
    done: 0,
    total: 1,
    loadedFiles: [],
    fileIdentifier: "",
    enteredFile: "",
    filesExpanded: false,
    addingFile: false,
    loadingFiles: false,
    hasLoadedFiles: false,
    isUploading: false,
  };
  uploadFile = async () => {
    if (!this.state.fileIdentifier) {
      cogoToast.error("Please enter a valid identifier for this file.");
      return;
    }
    if (!this.state.file) {
      cogoToast.error("Please choose a valid file.");
      return;
    }
    try {
      this.setState({ isUploading: true });
      cogoToast.loading("Uploading file...");
      const formData = new FormData();
      formData.append("associatedEntityId", this.props.data._id);
      formData.append("identifier", this.state.fileIdentifier);
      formData.append("file", this.state.file);
      await apiCallPostMultipartProgress(
        `/meta-sx/${this.props.authStore.prefix}/files/uploadNew`,
        formData,
        (done, total) => this.setState({ done: done, total: total })
      );
      this.setState(
        { isUploading: false, file: null, fileIdentifier: "" },
        () => this.getFiles()
      );
      cogoToast.success("Uploaded file.");
    } catch (err) {
      this.setState({ isUploading: false });
      console.log(err);
      cogoToast.error(
        "We ran into an error uploading this file. Please try again."
      );
    }
  };
  renderUploading = () => {
    if (this.state.isUploading) {
      let val = this.state.done / this.state.total;
      let intent = "danger";
      if (val >= 0.25) {
        intent = "warning";
      }
      if (val >= 0.6) {
        intent = "primary";
      }
      if (val >= 0.9) {
        intent = "success";
      }

      return (
        <ControlGroup vertical>
          <Tag minimal intent={intent}>
            {(val * 100).toFixed(2)}% Uploaded
          </Tag>
          <ProgressBar
            style={{ width: "50vw" }}
            intent={intent}
            value={this.state.done / this.state.total}
          />
        </ControlGroup>
      );
    }
  };
  getFiles = async () => {
    try {
      this.setState({ loadingFiles: true });
      let res = await apiCallPost(
        `/meta-sx/${this.props.authStore.prefix}/files/getByAssociatedEntity`,
        {
          associatedEntityId: this.props.data._id,
        }
      );

      this.setState({
        filesExpanded: true,
        loadedFiles: res,
        hasLoadedFiles: true,
      });
    } catch (err) {
      cogoToast.error(
        `We ran into an error while loading files. Please try again. If this error persists, please contact support immediately.`
      );
    } finally {
      this.setState({ loadingFiles: false });
    }
    return;
  };

  renderFiles = () => {
    let x = this.state.loadedFiles;
    if (!x.length) {
      return (
        <ControlGroup>
          <Tag minimal large>
            No files added. Start by adding a file below.
          </Tag>
        </ControlGroup>
      );
    }
    return x.map((each) => {
      return (
        <ControlGroup style={{ marginTop: "10px" }}>
          <Tag minimal large intent="success">
            {each.createdByName}
          </Tag>
          <Tag minimal large intent="warning">
            {niceDateTime(each.createdAt)}
          </Tag>
          <AnchorButton
            text={each.entityName}
            href={each.directLink}
            icon="document-share"
            target="_blank"
          />
        </ControlGroup>
      );
    });
  };
  renderFilesCard = () => {
    return (
      <>
        {" "}
        <ControlGroup>
          <Tag
            large
            minimal
            interactive
            icon="folder-open"
            onClick={() => {
              if (this.state.hasLoadedFiles) {
                this.setState({
                  filesExpanded: !this.state.filesExpanded,
                });
              } else {
                this.getFiles();
              }
            }}
          >
            {this.props.isTable ? null : (
              <>
                {!this.state.hasLoadedFiles
                  ? "Load Files"
                  : this.state.filesExpanded
                  ? `${this.state.loadedFiles.length} ${
                      this.state.loadedFiles.length === 1 ? "File" : "Files"
                    } `
                  : `View ${this.state.loadedFiles.length} ${
                      this.state.loadedFiles.length === 1 ? "File" : "Files"
                    }`}
              </>
            )}
          </Tag>
          {this.state.loadingFiles ? <Spinner size={20} /> : ""}
        </ControlGroup>
        <Collapse isOpen={this.state.filesExpanded}>
          {this.renderFiles()}
          <ControlGroup style={{ marginTop: "10px" }}>
            <Tag minimal large>
              Upload New File
            </Tag>
            <Tag minimal large intent="primary">
              Name
            </Tag>
            <InputGroup
              value={this.state.fileIdentifier}
              onChange={(event) =>
                this.setState({ fileIdentifier: event.target.value })
              }
            />
            <Tag minimal large intent="primary">
              File
            </Tag>{" "}
            <FileInput
              disabled={this.state.isUploading}
              text={this.state.file ? this.state.file.name : "Choose File"}
              buttonText="Choose"
              onInputChange={(event) => {
                this.setState({
                  file: event.target.files[0],
                });
              }}
            />
            {this.state.isUploading ? null : (
              <Button
                text="Upload"
                icon="cloud-upload"
                intent="success"
                onClick={() => this.uploadFile()}
              />
            )}{" "}
            <ControlGroup>
              {this.state.isUploading ? <>{this.renderUploading()}</> : null}
            </ControlGroup>
          </ControlGroup>
        </Collapse>
      </>
    );
  };
  render() {
    return (
      <div style={{ marginTop: `${this.props.isTable ? "" : "10px"}` }}>
        {this.renderFilesCard()}
      </div>
    );
  }
}

export default inject("authStore")(observer(EntityFiles));
